import { render, staticRenderFns } from "./linkedin.vue?vue&type=template&id=2b1751ae&"
import script from "./linkedin.vue?vue&type=script&lang=js&"
export * from "./linkedin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports